import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { setGuest } from 'redux/actions'
import { Container } from './styles';
import { ArrowIcon } from 'assets/icons';
import ModalReplyFromDashboard from 'screens/ModalReplyFromDashboard';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const MessageItem = ({
  mobile,
  markIncomingMessagesAsRead,
  markIncomingMessagesAsUnread,
  messageId,
  roomNumber,
  tenantId,
  contactValue,
  type,
  description,
  originator,
  createdAt,
  isRead,
  messages,
  setMessages,
}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch()

  return (
    <Container
      mobile={mobile}
      isRead={isRead}
    >
      <div
        className='messageBody'
        onClick={(event) => {
          // if(!isRead) {
          //   markIncomingMessagesAsRead({
          //     variables: {
          //       messageId: messageId,
          //     }
          //   }).then(() => {
          //     //TODO: maybe add some indication that message is read
          //   })
          // }
          if(!mobile) {
            if (event.metaKey || event.ctrlKey) {
              // Open new tab with absolute URL
              if(tenantId) {
                window.open(`https://pms.rookhotel.com/tenant-details/${tenantId}`, '_blank', 'noopener,noreferrer')
              }
            } else {
              // Normal navigation
              if(tenantId) {
                navigate({pathname: `/tenant-details/${tenantId}`, state: {communication: true}})
              }
            }
          } else {
            dispatch(setGuest(tenantId, type))
          }
        }}
      >
        <div className='messageInfo'>
          <span className='originator'>{originator}</span>
          <span className='roomNumber'>{`Room ${roomNumber}`}</span>
        </div>
        <div className='description'>{description}</div>
        <div className='dateTime'>
          {moment(createdAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}
        </div>
      </div>
      <ModalReplyFromDashboard
        iconStyle={`
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        `}
        buttonIcon={<ArrowIcon />}
        tenantId={tenantId}
      />
    </Container>
  )
}

export default MessageItem;
